<script lang="ts">
  import { getGalleryContext } from "./utils/context"

  let id: string | undefined = undefined
  export { id as for }

  const context = getGalleryContext(id)
</script>

<ol {...$$restProps} class={$$restProps.class}>
  {#each new Array($context.count) as _, idx}
    <li>
      <input type="radio" name="index" value={idx} bind:group={$context.selected} />
    </li>
  {/each}
</ol>

<style lang="postcss">
  ol {
    @apply flex justify-center gap-0.5;
  }

  li {
    @apply flex;
  }

  input {
    @apply h-2.5 w-2.5 cursor-pointer appearance-none p-0.5;

    &::after {
      @apply flex h-full w-full rounded-full bg-white transition-colors content-[""];
    }

    &:not(:checked)::after {
      @apply bg-opacity-60;
    }
  }
</style>
